import { handlePushNotification, isNotificationShown } from "../../helper/notificationHandler";
import React, { useContext, useEffect, useRef, useState, lazy, Suspense } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Bottombar from "../../components/Bottombar/Bottombar";
import BannerPart3 from "../../components/BannerPart3/BannerPart3";
// Sidebar moved to lazy import below
import {
  dataContext,
  baseUrl,
  portal,
  categoryEventId,
} from "../../App";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import styles from "./HomePageV3.module.css";
import homeImg from "../../assets/img/background/bg.png";
import activityLogSubmission from "../../helper/activitylog";
import analyticEvent, { setGAUserData } from "../../helper/gaEvent";
import submitRedeemCode from "../../helper/submitRedeemCode";
import { isPlayerHasFreePlayData } from "../../services/notification-popup/fetchFreePlayData";
import { isPlayerHasTournamentPlayData } from "../../services/notification-popup/fetchTournamenetPlayData";
import { isPlayerHasLastWeekWinnerPlayData } from "../../services/notification-popup/fetchLastWeekWinnerPlayData";
import { isPlayerHasMidWeekWinnerPlayData } from "../../services/notification-popup/fetchMidWeekWinnerPlayData";
import OpeningLoader from "../../components/OpeningLoader/OpeningLoader";

// Lazy load components and modals
const Sidebar = lazy(() => import("../../components/Sidebar/Sidebar"));
const LoginModal = lazy(() => import("../../components/LoginModal/LoginModal"));
const Profile = lazy(() => import("../../components/Profile/Profile"));
const ContactModal = lazy(() => import("../../components/Modal/ContactModal/ContactModal"));
const TCModal = lazy(() => import("../../components/Modal/TCModal/TCModal"));
const ReferralPolicyModal = lazy(() => import("../../components/Modal/ReferralPolicyModal/ReferralPolicyModal"));
const RefundModal = lazy(() => import("../../components/Modal/RefundModal/RefundModal"));
const RewardsModal = lazy(() => import("../../components/Modal/RewardsModal/RewardsModal"));
const SubscriptionModal = lazy(() => import("../../components/Modal/SubscriptionModal/SubscriptonModal"));
const UnSubscriptionModal = lazy(() => import("../../components/Modal/UnSubscriptionModal/UnSubscriptionModal"));
const ErrorSubscriptionModal = lazy(() => import("../../components/Modal/ErrorSubscriptionModal/ErrorSubscriptionModal"));
const RedeemModal = lazy(() => import("../../components/Modal/RedeemModal/RedeemModal"));
const ReferModal = lazy(() => import("../../components/Modal/ReferModal/ReferModal"));
const Referral = lazy(() => import("../../components/Referral/Referral"));
const OtpModal = lazy(() => import("../../components/Modal/OtpModal/OtpModal"));
const ShobDekho = lazy(() => import("../../components/Modal/ShobDekho/ShobDekho"));
const Category = lazy(() => import("../../components/Category/Category"));
const Subscription = lazy(() => import("../../components/Subscription/Subscription"));
const ResultPage = lazy(() => import("../../components/ResultPage/ResultPage"));
const Services = lazy(() => import("../../components/Services/Services"));
const QuizDetailsModal = lazy(() => import("../../components/Modal/QuizDetailsModal/QuizDetailsModal"));
const TrialPage = lazy(() => import("../../components/TrialPage/TrialPage"));
const CharnedUserModal = lazy(() => import("../../components/Modal/CharnedUserModal/CharnedUserModal"));
const TCModalTournament = lazy(() => import("../../components/Modal/TCModalTournament/TCModalTournament"));
const NewyearSuccessModal = lazy(() => import("../../components/Modal/NewyearSuccessModal/NewyearSuccessModal"));
const NewLeaderboard = lazy(() => import("../../components/NewLeaderboard/NewLeaderboard"));
const NewLeaderboardModal = lazy(() => import("../../components/Modal/NewLeaderboardModal/NewLeaderboardModal"));
const NewWinnerList = lazy(() => import("../../components/NewWinnerList/NewWinnerList"));
const FeedbackModal = lazy(() => import("../../components/Modal/FeedbackModal/FeedbackModal"));
const LoadingModal = lazy(() => import("../../components/Modal/LoadingModal/LoadingModal"));
const HomePageV3 = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = searchParams.get("page") || "home";
  const bottomBarPosition =
    pageParam === "subscription" || pageParam === "unsubscription"
      ? "subscription"
      : pageParam;
  const {
    token,
    setToken,
    playerData,
    setPlayerData,
    events,
    setOpeningLoader,
  } = useContext(dataContext);
  const [activeBottom, setActiveBottom] = useState(bottomBarPosition);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showOpeningBanner, setShowOpeningBanner] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showShobDekho, setShowShobDekho] = useState(false);
  const [showNewLeaderboardModal, setShowNewLeaderboardModal] = useState(false);
  const [showCharnedUserModal, setShowCharnedUserModal] = useState(false);
  const [showQuizDetailsModal, setShowQuizDetailsModal] = useState(false);
  const [activeQuizBannerId, setActiveQuizBannerId] = useState(34);
  const [showTCModal, setShowTCModal] = useState(false);
  const [showTCModalTournament, setShowTCModalTournament] = useState(false);
  const [showReferralPolicyModal, setShowReferralPolicyModal] = useState(false);
  const [showRewardsModal, setShowRewardsModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showReferModal, setShowReferModal] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showNewyearSuccessModal, setShowNewyearSuccessModal] = useState(false);
  const [showErrorSubscriptionModal, setShowErrorSubscriptionModal] =
    useState(false);
  const [showUnSubscriptionModal, setShowUnSubscriptionModal] = useState(false);
  const [toggleToUpdate, setToggleToUpdate] = useState(false);
  const [activeBoard, setActiveBoard] = useState(
    sessionStorage.getItem("leaderEventId")
      ? parseInt(sessionStorage.getItem("leaderEventId"))
      : events[0]?.id
  );
  const [activeLeaderPage, setActiveLeaderPage] = useState("singleLeaderPage");
  const [selectedRefund, setSelectedRefund] = useState(null)

  let checkFailedSubscription =
    searchParams.get("status") === "CANCELLED" ||
    searchParams.get("status") === "FAILED";
  let checkSuccessfulSubscription = searchParams.get("status") === "SUCCEEDED";


  // console.log(searchParams)
  const homePageBodyRef = useRef(null);
  let cid = sessionStorage.getItem("cid");
  let openingBanner = sessionStorage.getItem("opening_banner");
  let hiddenPopup = false;
  function hideOpeningBanner() {
    if (!hiddenPopup) {
      setShowOpeningBanner(false);
      hiddenPopup = true;
    }
  }
  useEffect(() => {
    if (playerData?.id) {
      let referCode = sessionStorage.getItem("refer_code");
      let hasAttemptedRedeem = sessionStorage.getItem("attempted_redeem");

      if (!playerData?.redeemed_code && referCode && !hasAttemptedRedeem) {
        // Set flag before attempting redeem
        sessionStorage.setItem("attempted_redeem", "true");

        submitRedeemCode(referCode)
          .then((response) => {
            // Handle successful redemption
            handlePushNotification('referNotification', 'বন্ধুকে রেফার করুন', 'দুজনেই জিতুন ১০ টাকা ক্যাশ ইন!', 'রেফার করুন', 'https://quizard.live/?page=referral', false);
            sessionStorage.removeItem("refer_code");
            console.log(response);
          })
          .catch((error) => {
            sessionStorage.removeItem("refer_code");
            // Handle error case
            console.error("Failed to redeem code:", error);
          });
      }
    }
  }, [playerData]);
  useEffect(() => {
    sessionStorage.removeItem("leaderEventId");
  }, []);

  function popUpBannerFunction(playerData = {}) {
    return;
    if (!playerData?.id) return;
    if (sessionStorage.getItem("login_event_id")) return;
    if (sessionStorage.getItem("banner_shown_session")) return;

    const today = new Date().toDateString();
    const bannerStats = JSON.parse(localStorage.getItem("banner_view_stats") || "{}");

    if (bannerStats.date === today && bannerStats.count >= 2) return;

    const updatedStats = {
      date: today,
      count: bannerStats.date === today ? bannerStats.count + 1 : 1,
    };

    localStorage.setItem("banner_view_stats", JSON.stringify(updatedStats));
    sessionStorage.setItem("banner_shown_session", "true");
    setShowOpeningBanner(true);
    activityLogSubmission("feedback-popup-banner-view");
    setTimeout(() => {
      hideOpeningBanner();
    }, 5000);
  }
  function popUpBannerClicked() {
    // quizClickHandlerInLogin(34, playerData);
    activityLogSubmission('feedback-popup-banner-click')
    setShowFeedbackModal(true)
  }
  useEffect(() => {
    searchParams.delete("page");
    setSearchParams(searchParams);
    // console.log(searchParams)
    if (searchParams.get("qcid")) {
      sessionStorage.setItem("cid", searchParams.get("qcid"));
      cid = searchParams.get("qcid");
    }
  }, [bottomBarPosition]);
  function callFloodlightTag() {
  }
  useEffect(() => {
    if (searchParams.get("status") === "SUCCEEDED") {
      let msisdn = localStorage.getItem("user_msisdn");
      console.log(msisdn);
      if (msisdn) {

      }
      setShowSubscriptionModal(true);
      analyticEvent("bkash-subscription", "bkash-subscription-success");
      activityLogSubmission(
        "subscription_success",
        localStorage.getItem("user_msisdn")
      );
    }
    if (
      searchParams.get("status") === "CANCELLED" ||
      searchParams.get("status") === "FAILED"
    ) {
      setShowErrorSubscriptionModal(true);
      analyticEvent("bkash-subscription", "bkash-subscription-failed");
      activityLogSubmission(
        "subscription_failed",
        localStorage.getItem("user_msisdn")
      );
    }
    searchParams.delete("status");
    setSearchParams(searchParams);

    if (searchParams.get("checkout_status") === "success") {
      setShowNewyearSuccessModal(true);
      analyticEvent(
        "tournament-onetime-subscription",
        "tournament-onetime-subscription-success"
      );
      activityLogSubmission(
        "tournament-onetime-subscription-success",
        localStorage.getItem("user_msisdn")
      );
    }
    searchParams.delete("checkout_status");
    setSearchParams(searchParams);
  }, []);
  function directBannerClick(activeUrlName, cleanPlayerData) {
    let activeBannerFromUrl = null;
    if (activeUrlName === 'quiz_weekly') activeBannerFromUrl = 34;
    if (activeUrlName === 'sports_weekly') activeBannerFromUrl = 75;
    if (activeUrlName === 'bcs_weekly') activeBannerFromUrl = 149;
    if (activeUrlName === 'tournament_weekly') activeBannerFromUrl = 150;
    if (activeBannerFromUrl) { quizClickHandlerInLogin(activeBannerFromUrl, cleanPlayerData) }
  }
  const serviceMap = {
    "08012092000001096": "isSubscribeWeekly",
    "08012092000001097": "isSubscribeDaily",

    "08012092000001098": "isSubscribeSportsWeekly",
    "08012092000001099": "isSubscribeSportsDaily",

    "08012092000001100": "isSubscribeBcsWeekly",
    "08012092000001101": "isSubscribeBcsDaily",

    "08012092000001102": "isSubscribeTournamentWeekly",
    "08012092000001103": "isSubscribeTournamentDaily",
  };
  useEffect(() => {
    const handleFlow = async () => {
      const transactionId = searchParams.get("transactionId");

      // ✅ STEP 1: Confirm subscription if transactionId exists
      if (transactionId) {
        try {
          await axios.get(
            `https://robiapi.arcaderush.xyz/api/RobiSubscription/confirmSubscription`,
            {
              params: { transactionId },
            }
          );

          // ✅ remove transactionId from URL
          searchParams.delete("transactionId");
          searchParams.delete("resultCode");
          searchParams.delete("isDoubleConfrim");
          searchParams.delete("cnfmResult");
          setSearchParams(searchParams);
        } catch (error) {
          console.log("Confirm Subscription Failed:", error);
        }
      }

      // ✅ STEP 2: Existing logic
      if (!token) {
        setPlayerData({});
        popUpBannerFunction({});
        directBannerClick(searchParams.get("active"), {});
        return;
      }

      const config = {
        headers: { Authorization: `Token ${token}` },
      };

      const serviceIds = Object.keys(serviceMap);
      const msisdn = localStorage.getItem("user_msisdn");

      try {
        if (!playerData?.id) {
          setOpeningLoader(true);
        }

        const participantPromise = axios.get(
          `${baseUrl}/api/clients/participant_profile_only/?portal=${portal}`,
          config
        );

        const subscriptionPromises = serviceIds.map((serviceId) =>
          axios.post(
            "https://robiapi.arcaderush.xyz/api/RobiSubscription/checkSubscription",
            {
              serviceId,
              userMsisdn: `0${msisdn}`,
            }
          )
        );

        const [participantRes, subscriptionResults] = await Promise.all([
          participantPromise,
          Promise.allSettled(subscriptionPromises),
        ]);

        const participant = participantRes.data[0];

        let updatedData = {
          ...participant,

          isSubscribeDaily: false,
          isSubscribeWeekly: false,

          isSubscribeSportsDaily: false,
          isSubscribeSportsWeekly: false,

          isSubscribeBcsDaily: false,
          isSubscribeBcsWeekly: false,

          isSubscribeTournamentDaily: false,
          isSubscribeTournamentWeekly: false,
        };

        subscriptionResults.forEach((res, index) => {
          if (res.status === "fulfilled") {
            const serviceId = serviceIds[index];
            const field = serviceMap[serviceId];

            const apiResponse = res.value.data;

            if (
              apiResponse?.success === true &&
              apiResponse?.data?.isSubscribed === true
            ) {
              updatedData[field] = true;
            }
          }
        });

        // ✅ aggregate
        updatedData.isSubscribe =
          updatedData.isSubscribeDaily || updatedData.isSubscribeWeekly;

        updatedData.isSubscribeSports =
          updatedData.isSubscribeSportsDaily ||
          updatedData.isSubscribeSportsWeekly;

        updatedData.isSubscribeBcs =
          updatedData.isSubscribeBcsDaily ||
          updatedData.isSubscribeBcsWeekly;

        updatedData.isSubscribeTournament =
          updatedData.isSubscribeTournamentDaily ||
          updatedData.isSubscribeTournamentWeekly;

        setOpeningLoader(false);
        setPlayerData(updatedData);

        directBannerClick(searchParams.get("active"), updatedData);

        if (sessionStorage.getItem("login_event_id")) {
          quizClickHandlerInLogin(
            parseInt(sessionStorage.getItem("login_event_id")),
            updatedData
          );
          sessionStorage.removeItem("login_event_id");
        }
      } catch (error) {
        console.log("ERROR:", error);

        popUpBannerFunction({});
        setOpeningLoader(false);
        directBannerClick(searchParams.get("active"), {});

        localStorage.setItem("AuthToken", "");
        localStorage.setItem("user_msisdn", "");

        setPlayerData({});
        setToken(null);
      }
    };

    handleFlow();
  }, [token, toggleToUpdate]);



  let backgroundImg;
  activeBottom === "leader"
    ? (backgroundImg = homeImg)
    : (backgroundImg = homeImg);
  // const [showProfile, setShowProfile] = useState(false);
  // (playerData?.id)? setShowProfile(true):setShowProfile(false)
  async function quizClickHandlerInLogin(eventId, playerData) {
    console.log(playerData);
    if (!playerData?.id) {
      sessionStorage.setItem("login_event_id", eventId);
      setShowLoginModal(true);
      return;
    } else if (categoryEventId.includes(eventId)) {
      // Category-International, Category-Sports, Category-Science and Technology, Category-General Knowledge, Category-Bangladesh
      // if (eventId === 42) { clevertap.event.push("Category-International"); }
      // if (eventId === 43) { clevertap.event.push("Category-Sports"); }
      // if (eventId === 44) { clevertap.event.push("Category-Bangladesh"); }
      // if (eventId === 46) { clevertap.event.push("Category-General Knowledge"); }
      // if (eventId === 76) { clevertap.event.push("Category-Science and Technology"); }
      navigate(`/quiz/?eventId=${eventId}`, { replace: true });
    }
    setShowQuizDetailsModal(true);
    setActiveQuizBannerId(eventId);
    sessionStorage.removeItem("login_event_id");
    return;
  }

  return (
    <div
      className={styles.homePageBody}
      ref={homePageBodyRef}
      style={{ background: "#f5f5f5" }}
    >
      <div className={styles.extraHiddenFile}>
        বাংলাদেশের শীর্ষ ও নব্য কুইজ গেম QUIZARD ! সাম্প্রতিক ঘটনা সহ বিবিধ
        ঘটনার উপর কুইজ খেলুন, শিখুন, আর প্রতিদিন জিতুন পুরষ্কার।
        <details open>
          <summary>About Quizard Live / কুইজার্ড সম্পর্কে</summary>

          <section>
            <h2>Quizard Live – Free Online Quiz Game | কুইজার্ড</h2>
            <h2>বাংলাদেশের জনপ্রিয় অনলাইন কুইজ – Quizard Live</h2>

            <p>
              Quizard Live বাংলাদেশের একটি অনলাইন কুইজ প্ল্যাটফর্ম যেখানে আপনি
              বাংলা এবং ইংরেজি কুইজ খেলতে পারবেন।
            </p>

            <p>
              Quizard Live is a free and premium online quiz platform where you can play trivia,
              test your knowledge and enjoy daily challenges. কুইজার্ড একটি অনলাইন
              কুইজ প্ল্যাটফর্ম যেখানে আপনি বাংলা এবং ইংরেজি কুইজ খেলতে পারবেন।
            </p>

            <h3>Play Online Quiz in Bangladesh – অনলাইন কুইজ খেলুন</h3>

            <p>
              Join thousands of players in Bangladesh and play quiz games.
              অনলাইন কুইজ খেলুন, জ্ঞান বাড়ান এবং নতুন চ্যালেঞ্জ নিন Quizard Live এ।
            </p>

            <ul>
              <li>Free quiz game</li>
              <li>Online trivia Bangladesh</li>
              <li>বাংলা কুইজ</li>
              <li>কুইজার্ড লাইভ</li>
              <li>Daily quiz challenge</li>
            </ul>

            {/* AEO FAQ BLOCK */}
            <h3>FAQ – Quizard Live</h3>

            <p><strong>Quizard কি ফ্রি?</strong><br />
              হ্যাঁ, Quizard Live একটি ফ্রি এবং প্রিমিয়াম অনলাইন কুইজ গেম।</p>

            <p><strong>Is Quizard Live free to play?</strong><br />
              Yes, you can play quizzes online for free without download and there is a premium version available.</p>

          </section>
        </details>
      </div>
      {showOpeningBanner && (
        <div className={styles.initialBanner}>
          <div className={styles.closeBtn} onClick={hideOpeningBanner}>
            X
          </div>
          <img
            src={"/banners/popup/feedback_popup.png"}
            alt=""
            srcSet=""
            className={styles.openingBannerImg}
            onClick={() => {
              hideOpeningBanner();
              popUpBannerClicked();
            }}
          />
        </div>
      )}
      <Suspense fallback={null}>
        <Sidebar
          props={{
            showSidebar,
            setShowSidebar,
            setShowLoginModal,
            showLoginModal,
            activeBottom,
            setActiveBottom,
            showContactModal,
            setShowContactModal,
            showTCModal,
            setShowTCModal,
            showReferralPolicyModal,
            setShowReferralPolicyModal,
            showRefundModal,
            setShowRefundModal,
            showRewardsModal,
            setShowRewardsModal,
          }}
        ></Sidebar>
      </Suspense>
      <div className={styles.fixedNavbar}>
        <Navbar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      </div>
      <div className={styles.scrollableContent} ref={homePageBodyRef}>
        <Suspense fallback={<OpeningLoader />}>
          {activeBottom === "home" && (
            <BannerPart3
              props={{
                quizClickHandler: quizClickHandlerInLogin,
                setShowLoginModal,
                showLoginModal,
                setShowShobDekho,
                setShowLoadingModal,
                showLoadingModal,
                showRedeemModal,
                setShowRedeemModal,
                setShowReferModal,
                setActiveBottom,
                homePageBodyRef,
              }}
            ></BannerPart3>
          )}
          {activeBottom === "referral" && (
            <Referral
              props={{
                setShowLoginModal,
                showLoginModal,
                setShowLoadingModal,
                showLoadingModal,
                showRedeemModal,
                setShowRedeemModal,
                setShowReferModal,
                setActiveBottom,
              }}
            ></Referral>
          )}
          {activeBottom === "category" && (
            <Category
              events={events}
              quizClickHandler={quizClickHandlerInLogin}
              setShowShobDekho={setShowShobDekho}
            ></Category>
          )}
          {activeBottom === "tournaments" && (
            <Services
              props={{ quizClickHandlerInLogin, setShowLoginModal, showLoginModal, setShowLoadingModal, showLoadingModal }}
            ></Services>
          )}
          {activeBottom === "winner" && (
            <NewWinnerList
              setShowNewLeaderboardModal={setShowNewLeaderboardModal}
            />
          )}
          {activeBottom === "leader" && (
            <NewLeaderboard
              setShowNewLeaderboardModal={setShowNewLeaderboardModal}
            />
          )}
          {activeBottom === "profile" && (
            <Profile
              showLoginModal={showLoginModal}
              setShowLoginModal={setShowLoginModal}
              setShowReferModal={setShowReferModal}
              setActiveBottom={setActiveBottom}
              quizClickHandler={quizClickHandlerInLogin}
              setActiveQuizBannerId={setActiveQuizBannerId}
              setShowQuizDetailsModal={setShowQuizDetailsModal}
              setSelectedRefund={setSelectedRefund}
              setShowRefundModal={setShowRefundModal}
            ></Profile>
          )}
          {activeBottom === "subscription" && (
            <Subscription
              quizClickHandler={quizClickHandlerInLogin}
              setShowLoginModal={setShowLoginModal}
              setSelectedRefund={setSelectedRefund}
              setShowRefundModal={setShowRefundModal}
              setActiveQuizBannerId={setActiveQuizBannerId}
              setShowQuizDetailsModal={setShowQuizDetailsModal}
            ></Subscription>
          )}
          {activeBottom === "rewards" && (
            <RewardsModal
              showRewardsModal={showRewardsModal}
              setShowRewardsModal={setShowRewardsModal}
            ></RewardsModal>
          )}
          {activeBottom === "help" && (
            <ContactModal
              showContactModal={showContactModal}
              setShowContactModal={setShowContactModal}
              setShowRefundModal={setShowRefundModal}
            ></ContactModal>
          )}
          {activeBottom === "tc" && (
            <TCModal
              showTCModal={showTCModal}
              setShowTCModal={setShowTCModal}
              showRefundModal={showRefundModal}
              setShowRefundModal={setShowRefundModal}
            ></TCModal>
          )}
          {activeBottom === "result" && (
            <ResultPage
              quizClickHandler={quizClickHandlerInLogin}
              setActiveBottom={setActiveBottom}
              setActiveBoard={setActiveBoard}
              setShowFeedbackModal={setShowFeedbackModal}
            ></ResultPage>
          )}
          {activeBottom === "trialPage" && <TrialPage></TrialPage>}
        </Suspense>
      </div>
      <div className={styles.fixedBottombar}>
        <Bottombar
          activeBottom={activeBottom}
          setActiveBottom={setActiveBottom}
          setShowLoginModal={setShowLoginModal}
          activeLeaderPage={activeLeaderPage}
          setActiveLeaderPage={setActiveLeaderPage}
          setShowShobDekho={setShowShobDekho}
        />
      </div>
      <Suspense fallback={null}>
        {showLoginModal && (
          <LoginModal
            showLoginModal={showLoginModal}
            setShowLoginModal={setShowLoginModal}
            activeBottom={activeBottom}
            setActiveBottom={setActiveBottom}
            setShowOtpModal={setShowOtpModal}
            setShowTCModalTournament={setShowTCModalTournament}
            setShowLoadingModal={setShowLoadingModal}
          ></LoginModal>
        )}
        {showLoadingModal && (
          <LoadingModal
            showLoadingModal={showLoadingModal}
            setShowLoadingModal={setShowLoadingModal}
          ></LoadingModal>
        )}
        {showFeedbackModal && (
          <FeedbackModal
            showFeedbackModal={showFeedbackModal}
            setShowFeedbackModal={setShowFeedbackModal}
          ></FeedbackModal>
        )}
        {showTCModalTournament && (
          <TCModalTournament
            showTCModalTournament={showTCModalTournament}
            setShowTCModalTournament={setShowTCModalTournament}
          ></TCModalTournament>
        )}
        {showReferModal && (
          <ReferModal
            showReferModal={showReferModal}
            setShowReferModal={setShowReferModal}
          ></ReferModal>
        )}
        {showRedeemModal && (
          <RedeemModal
            showRedeemModal={showRedeemModal}
            setShowRedeemModal={setShowRedeemModal}
            setShowLoadingModal={setShowLoadingModal}
            setToggleToUpdate={setToggleToUpdate}
            toggleToUpdate={toggleToUpdate}
          ></RedeemModal>
        )}
        {showOtpModal && (
          <OtpModal
            showOtpModal={showOtpModal}
            setShowOtpModal={setShowOtpModal}
            activeBottom={activeBottom}
          ></OtpModal>
        )}
        {showSubscriptionModal && (
          <SubscriptionModal
            showSubscriptionModal={showSubscriptionModal}
            setShowSubscriptionModal={setShowSubscriptionModal}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          ></SubscriptionModal>
        )}
        {showNewyearSuccessModal && (
          <NewyearSuccessModal
            showNewyearSuccessModal={showNewyearSuccessModal}
            setShowNewyearSuccessModal={setShowNewyearSuccessModal}
          ></NewyearSuccessModal>
        )}
        {showErrorSubscriptionModal && (
          <ErrorSubscriptionModal
            showErrorSubscriptionModal={showErrorSubscriptionModal}
            setShowErrorSubscriptionModal={setShowErrorSubscriptionModal}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          ></ErrorSubscriptionModal>
        )}
        {showUnSubscriptionModal && (
          <UnSubscriptionModal
            showUnSubscriptionModal={showUnSubscriptionModal}
            setShowUnSubscriptionModal={setShowUnSubscriptionModal}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          ></UnSubscriptionModal>
        )}
        {showShobDekho && (
          <ShobDekho
            showShobDekho={showShobDekho}
            setShowShobDekho={setShowShobDekho}
            quizClickHandler={quizClickHandlerInLogin}
          ></ShobDekho>
        )}
        {showNewLeaderboardModal && (
          <NewLeaderboardModal
            activeBoard={activeBoard}
            activeBottom={activeBottom}
            showNewLeaderboardModal={showNewLeaderboardModal}
            setShowNewLeaderboardModal={setShowNewLeaderboardModal}
          ></NewLeaderboardModal>
        )}
        {showCharnedUserModal && (
          <CharnedUserModal
            showCharnedUserModal={showCharnedUserModal}
            setShowCharnedUserModal={setShowCharnedUserModal}
            quizClickHandler={quizClickHandlerInLogin}
          ></CharnedUserModal>
        )}
        {showQuizDetailsModal && (
          <QuizDetailsModal
            showQuizDetailsModal={showQuizDetailsModal}
            setShowQuizDetailsModal={setShowQuizDetailsModal}
            activeQuizBannerId={activeQuizBannerId}
          ></QuizDetailsModal>
        )}
        {showReferralPolicyModal && (
          <ReferralPolicyModal
            showReferralPolicyModal={showReferralPolicyModal}
            setShowReferralPolicyModal={setShowReferralPolicyModal}
          ></ReferralPolicyModal>
        )}
        {showRefundModal && (
          <RefundModal
            showRefundModal={showRefundModal}
            setShowRefundModal={setShowRefundModal}
            setToggleToUpdate={setToggleToUpdate}
            toggleToUpdate={toggleToUpdate}
            setShowUnSubscriptionModal={setShowUnSubscriptionModal}
            selectedRefund={selectedRefund}
            setSelectedRefund={setSelectedRefund}
          ></RefundModal>
        )}
      </Suspense>
    </div>
  );
};

export default HomePageV3;
